import { IPlanificationProfileScheduler } from '@/entity/planification/planification-profile-scheduler';
import { dateToString } from '../calendar-helper';

export interface ShiftedObj {
    type: 'phase' | 'user';
    phaseId: number;
    profileId: number | null;
}

export interface FormatDate {
    date: Date;
    formatted: string;
}

export interface ShiftedWorkDate {
    dateToRemoved: FormatDate,
    shiftDate: FormatDate,
}

export interface CalculatedDate {
  shiftCount: number
  workoutDates: ShiftedWorkDate[];
  min: string | string;
  max: string | string;
}

export interface ConfigShifted {
    key: string;
    phase: IPlanificationProfileScheduler;
    shifts: CalculatedDate | null;
}

export const newShiftedWorkDate = (oldDate: Date, shiftDate: Date) => {
    return {
        dateToRemoved: {
            date: oldDate,
            formatted: dateToString(oldDate, 'dd/MM/yyyy', 0)
        },
        shiftDate: {
            date: shiftDate,
            formatted: dateToString(shiftDate, 'dd/MM/yyyy', 0)
        }
    } as ShiftedWorkDate;
};

export const replaceWorkoutDateByShiftedDate = (configShited: ConfigShifted[]): IPlanificationProfileScheduler[] => {
    const results = configShited.map(cs => {
        const workoutWithShifted = cs.phase.planificationPhaseProfileWorkDays
            .map(w => {
                const dateToShift = cs.shifts && cs.shifts.workoutDates.find(wd => wd.dateToRemoved.date === w.date);
                if (dateToShift) {
                    return {
                        ...w,
                        date: dateToShift.shiftDate.date,
                        isShifted: true,
                    };
                } else {
                    return w;
                }
            });
        return {
            ...cs.phase,
            planificationPhaseProfileWorkDays: workoutWithShifted,
        };
    });
    return results;        
};

export const isShiftSelected = (
    shiftedProfiles: IPlanificationProfileScheduler[],
    baseProfiles: IPlanificationProfileScheduler[],
    profile: IPlanificationProfileScheduler): boolean => {
    let selected = false;
    if (profile.parentPhaseId === 0) {
        const shilftChildCount = shiftedProfiles.filter(sp => 
            sp.parentPhaseId > 0 && sp.contractLineId === profile.contractLineId).length;
        const childPhaseCount = baseProfiles.filter(p => p.parentPhaseId > 0 && p.contractLineId === profile.contractLineId).length;
        selected = childPhaseCount > 0 && shilftChildCount === childPhaseCount;
    } else {
        selected = !!shiftedProfiles.find(sp => 
            sp.contractLineId === profile.contractLineId &&
            sp.employeeId === profile.employeeId &&
            sp.profileId === profile.profileId &&
            sp.indexInPhase === profile.indexInPhase
        );
    }

    return selected;
};
